import React from "react";
import betSound from "../../../../../../assets/sounds/bet.mp3";
import { connect } from "react-redux";
import closeImg from '../../../../../../assets/am_close.svg';

class RightButtonPanel extends React.Component {
  constructor(props) {
    super(props);
    this.gameHistroy = [];
    this.filterHistory = [];
    this.historyArray = [];
    setTimeout(() => {
      // this.updateHistory();
    }, 100);
  }
  componentDidMount() {
    const { childRef } = this.props
    childRef(this)
  }
  updateHistory() {
    this.historyArray = []
    if (this.props.gameState.history !== undefined && this.props.gameState.history.length !== 0) {
      this.gameHistroy = this.props.gameState.history;
      this.filterHistory = this.gameHistroy.slice(Math.max(this.gameHistroy.length - 5, 0));
      for (let k = 0; k < this.filterHistory.length; k++) {
        let idNo = Number(this.filterHistory[k].resultNo) + 1
        let resClassList = document.getElementById("id_" + idNo).parentElement.classList;
        const hist = {
          numb: this.filterHistory[k].resultNo,
          color: resClassList[0],
        };
        this.historyArray.push(hist);
      }
    }
  }
  render() {
    return (
      <div className="fd roulette_grid_buttons">
        {/* <div className="ar_close"> 
              <button onClick={(e)=>{e.preventDefault();this.props.action("exit");}}>
                <img src={closeImg} alt={closeImg}/>
              </button>
            </div> */}

        <div className="weelZoom_div_container">
          <div className="toggle-wrapper american_non_timer">
            <input
              id="zoomBtn"
              className="toggle-checkbox"
              type="checkbox"
              disabled={this.props.disZoomBtn === 1}
              checked={!this.props.zoomButtonValue}
              onChange={(e) => {
                if (this.props.zoomButtonValue === 0) {
                  this.props.action("ZoomON");
                } else if (this.props.zoomButtonValue === 1) {
                  this.props.action("ZoomOFF");
                }
              }}
            />
            <div className="toggle-container">
              <div className="toggle-button">
                <div className={`toggle-button-circles-container`}>
                  {Array.from({ length: 12 }).map((_, i) => (
                    <div key={i} className={`toggle-button-circle ${!this.props.zoomButtonValue ? "checked" : ""}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <span className="m_t_15">{this.props.zoomButtonText}</span>
        </div>


        {/* <button type="button" className="mobile-menu-icon" onClick={() => this.props.action("showMenu")}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" /></svg>
        </button> */}
        {/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Zm-40-60v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z" /></svg> */}
        <div className="history history_AR fd box_clm">
          <div id="rouletteCover" className="rouletteCover"></div>
          <div className="fd clr_ff text-center m_b_5 font_30 histTxt">{this.props.language.History}</div>
          <div className="fd">
            <table className="fd american_HistoryTbl" cellPadding="0" cellSpacing="0">
              <tbody>
                <tr>
                  {this.historyArray !== 0 ? (
                    this.historyArray.map((value, index) => {
                      return (
                        <td key={index}>
                          {" "}
                          <span style={{ color: value.color }}> {value.numb == 37 ? '00' : value.numb} </span>{" "}
                        </td>
                      );
                    })
                  ) : (
                    <td> &nbsp; </td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* <div className={`mobile-menu-items ${this.props.showMenu ? "showMenu" : ""}`}> */}
        <div className={`mobile-menu-items showMenu`}>
          <div className="fd">
            <button
              id="zoomBtn"
              className="fd ar_bt_1"
              disabled={this.props.disZoomBtn === 1}
              name={this.props.zoomButtonText}
              onClick={(e) => {
                e.preventDefault();
                console.log(e.target.name);
                if (this.props.zoomButtonValue === 0) {
                  this.props.action("ZoomON");
                }
                if (this.props.zoomButtonValue === 1) {
                  this.props.action("ZoomOFF");
                }
              }}
            >
              {this.props.zoomButtonText}
            </button>
          </div>

          <div className="fd">
            <button
              id="bet_take"
              className={this.props.btnActive ? "fd ar_bt_1 active z_1020" : "fd ar_bt_1 z_0"}
              name={this.props.betBtnText}
              disabled={this.props.disBetBtn === 1 && this.props.betBtnText !== "TAKE"}
              onClick={(e) => {
                e.preventDefault();
                console.log(e.target.name);

                // let betSound;
                if (this.props.betButtonValue === 2) {
                  console.log("TAKE Button ");
                  this.props.action("TAKE");
                } else if (this.props.betButtonValue === 0) {
                  console.log("Prev Button Name: " + e.target.name);
                  this.props.action("PREV");
                } else if (this.props.betButtonValue === 1) {
                  console.log("Send Bet Request");
                  this.betSound = new Audio(betSound);
                  this.betSound.play();
                  this.props.action("SPIN");
                }
              }}
            >
              {this.props.betBtnText}
            </button>
          </div>
          <div className="fd">
            <button className="fd ar_bt_1" onClick={(e) => {
              e.preventDefault();
              this.props.action("double")
            }} disabled={this.props.disDoubleBtn === 1}> {this.props.language.Double}
            </button>
          </div>
          <div className="fd">
            <button className="fd ar_bt_1" onClick={(e) => {
              e.preventDefault();
              this.props.action("clear")
            }} disabled={this.props.disClearBtn === 1}>{this.props.language.Clear}
            </button>
          </div>
        </div>
      </div>
    );
  }
}


const mapStatesToProps = (state) => {
  return {
    language: state.languageObjs.languageObj
  }
}
export default connect(mapStatesToProps)(RightButtonPanel)

